var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-top",class:{'is-active': _vm.isVisible},on:{"click":function($event){$event.preventDefault();return _vm.scrollTop.apply(null, arguments)}}},[_c('i',{staticClass:"ls-icon ls-icon--type_up-chevron"})])
}
var staticRenderFns = []

export { render, staticRenderFns }